import React, { Component } from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import styles from './toggle-button.module.css'

const toggleButtonPropTypes = {
    checked: PropTypes.bool,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    onChange: PropTypes.func
}

const toggleButtonDefaultProps = {
    checked: false,
    disabled: false,
    onChange() {}
}

class ToggleButton extends Component {
    constructor(props) {
        super(props)
        this.props = props
        this.state = {
            checked: props.checked
        }
        this.onChange = this.onChange.bind(this)
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { checked } = nextProps

        this.setState({ checked })
    }

    render() {
        const { className, disabled } = this.props
        const { checked } = this.state
        const classNameMerged = cx(styles['toggle-button'], className, {
            ['t3sel-toggle-button-picker-checked']: checked,
            ['t3sel-toggle-button-picker-disabled']: disabled,
            ['t3sel-toggle-button-picker-enabled']: !disabled,
            ['t3sel-toggle-button-picker-unchecked']: !checked,
            [styles['checked']]: checked,
            [styles['disabled']]: disabled
        })

        return (
            <div className={classNameMerged}>
                <div className={styles['toggle-button-picker']} onClick={this.onChange} />
            </div>
        )
    }

    onChange(event) {
        const checked = !this.state.checked
        event.target.checked = checked

        const { disabled, onChange } = this.props
        if (!disabled) {
            this.setState({ checked })
            if (onChange) {
                onChange(event)
            }
        }
    }
}

ToggleButton.propTypes = toggleButtonPropTypes
ToggleButton.defaultProps = toggleButtonDefaultProps

export default ToggleButton
